// extracted by mini-css-extract-plugin
module.exports = {"parent":"scene3_parent__ocZvU"};